import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';

export const StyledFlexContainer = styled(FlexContainer)`
  .toast-icon {
    margin-right: 5px;
  }
  .toast-info {
    font-weight: bold;
  }
  .toast-msg {
    font-weight: bold;
    color: black;
  }
`;
